module.exports = "static/assets/311ef566eba52b1729fd02d8944b4378.mp3";